import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import DICoatOfArms from '../../../assets/DI_CoatOfArms.svg';

export interface DigitalIdentityButtonProps {
    to: any;
    children: ReactNode;
    className?: string;
}

const DigitalIdentityButton = ({
    to,
    children,
    className = '', // default props
} : DigitalIdentityButtonProps) => (
    <Link to={to} className={`btn btn-nmi-secondary btn-digitalidentity ${className}`}>
        <span>
            <img src={DICoatOfArms} alt='Australian Government Coat of Arms' className='me-3' />
        </span>
        <span className='align-self-center'>
            {children}
        </span>
    </Link>
);

// DigitalIdentityButton.defaultProps = {
//     className: '',
// };

export default DigitalIdentityButton;
